'use strict';

var _betterXlsx = require('better-xlsx');

var _betterXlsx2 = _interopRequireDefault(_betterXlsx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = html => {
  const file = new _betterXlsx2.default.File();

  const sheet = file.addSheet('Sheet1');
  const row = sheet.addRow();
  const cell = row.addCell();

  cell.value = 'I am a cell!';
  cell.hMerge = 2;
  cell.vMerge = 1;

  const style = new _betterXlsx2.default.Style();

  style.fill.patternType = 'solid';
  style.fill.fgColor = '00FF0000';
  style.fill.bgColor = 'FF000000';
  style.align.h = 'center';
  style.align.v = 'center';

  cell.style = style;
  return file;
};